<template>
  <div class="card p-shadow-app p-p-4">
    <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
      <h2 class="p-m-0">Clientes</h2>
    </div>

    <div style="height: 65vh">
      <DataTable
        :value="clients"
        :filters.sync="filters"
        :loading="loading"
        responsiveLayout="scroll"
        filterDisplay="row"
        class="p-datatable-sm"
        scrollable
        scrollHeight="flex"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 20, 50, 100]"
        :lazy="true"
        :totalRecords="totalRecords"
        @filter="fetchClients"
        @page="fetchClients"
      >
        <template #header>
          <div>
            <Button
              icon="pi pi-plus"
              @click="createClient()"
              v-if="can('manageEquipments')"
            />
          </div>
        </template>
        <template #empty> Nenhum cliente encontrado. </template>
        <template #loading> A carregar... </template>

        <Column
          field="id"
          header="ID"
          filterField="id"
          :headerStyle="{ 'min-width': '8%', 'max-width': '8%' }"
          :filterHeaderStyle="{ 'min-width': '8%', 'max-width': '8%' }"
          :bodyStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="name"
          header="Nome"
          filterField="name"
          :headerStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :filterHeaderStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :bodyStyle="{ 'min-width': '15%', 'max-width': '15%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="email"
          header="Email"
          filterField="email"
          :headerStyle="{ 'min-width': '17%', 'max-width': '17%' }"
          :filterHeaderStyle="{ 'min-width': '17%', 'max-width': '17%' }"
          :bodyStyle="{ 'min-width': '17%', 'max-width': '17%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="telephone"
          header="Telefone"
          filterField="telephone"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="mobilPhone"
          header="Telemóvel"
          filterField="mobilPhone"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="address"
          header="Morada"
          filterField="address"
          :headerStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :filterHeaderStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :bodyStyle="{ 'min-width': '15%', 'max-width': '15%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="city"
          header="Localidade"
          filterField="city"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="fiscalNumber"
          header="NIF"
          filterField="fiscalNumber"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          header="Ações"
          v-if="can('manageClients')"
          :headerStyle="{ 'min-width': '5%', 'max-width': '5%' }"
          :filterHeaderStyle="{ 'min-width': '5%', 'max-width': '5%' }"
          :bodyStyle="{ 'min-width': '5%', 'max-width': '5%' }"
        >
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-sm p-button-text"
              @click="updateClient(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <ClientModal
      :visible.sync="modalVisible"
      :data="formData"
      @cancel="closeForm"
      @created="createdClient"
      @updated="updatedClient"
    />
  </div>
</template>

<script>
import ClientService from "@/services/client.service";
import { FilterMatchMode } from "primevue/api";
import ClientModal from "@/components/clients/ClientModal.vue";

export default {
  name: "ClientList",
  components: { ClientModal },
  data() {
    return {
      loading: false,
      clients: [],
      totalRecords: 0,
      currentPage: 1,
      perPage: 50,
      modalVisible: false,
      formData: {
        id: null,
        fullName: "",
        taxNumber: "",
        phone: "",
        mobilePhone: "",
        email: "",
        address: "",
        city: "",
        postalCode: "",
      },
      filters: {
        id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        telephone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        mobilPhone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        fiscalNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
        address: { value: null, matchMode: FilterMatchMode.CONTAINS },
        city: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  async activated() {
    await this.fetchClients();
  },
  async created() {
    await this.fetchClients();
  },
  methods: {
    buildQueryParams(page = 1) {
      const params = new URLSearchParams();
      params.append('page', page);

      for (const [key, filter] of Object.entries(this.filters)) {
        if (filter.value !== null && filter.value !== '') {
          params.append(`filters[${key}]`, filter.value);
        }
      }

      return params;
    },
    async fetchClients(event = {}) {
      try {
        this.loading = true;

        const page = event.page ? event.page + 1 : 1;
        const params = this.buildQueryParams(page);
        params.append('per_page', event.rows || this.perPage);

        const response = await ClientService.index(params);

        if (response) {
          this.clients = response.data;
          this.totalRecords = response.meta.total;
          this.currentPage = response.meta.current_page;
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar clientes',
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    emptyFormData() {
      return (this.formData = {
        id: null,
        fullName: "",
        taxNumber: "",
        phone: "",
        mobilePhone: "",
        email: "",
        address: "",
        city: "",
        postalCode: "",
        country_origin: '0',
      });
    },
    closeForm() {
      this.modalVisible = false;
      return this.emptyFormData();
    },
    createClient() {
      this.emptyFormData();
      return (this.modalVisible = true);
    },
    createdClient() {
      this.fetchClients();
      return this.closeForm();
    },
    updateClient(client) {
      this.formData = { ...client };
      return (this.modalVisible = true);
    },
    updatedClient() {
      this.fetchClients({ page: this.currentPage - 1, rows: this.perPage });
      return this.closeForm();
    },
  },
};
</script>
